import { useLocation } from 'react-router-dom';
import { getBankAccountId, getSelectedBankAccountId } from '../utils';
/** The bank account to charge: the customer's own choice when they made one, otherwise the account on file. */
function useEffectiveBankAccountId(finalizeData) {
    const { search } = useLocation();
    return getSelectedBankAccountId(search) ?? getBankAccountId(finalizeData);
}
export default useEffectiveBankAccountId;
